import React from "react";
import "./App.css";
import logo from "./img/logo.png"; // Add logo if needed
import share from "./img/share.png"; // Add share icon if needed
import insta from "./img/instagram.png"; // Example icon
import appStore from "./img/appstore.png"; // App Store icon
import playStore from "./img/playstore.png"; // Play Store icon
import youtube from "./img/youtube.png"; // YouTube icon
import whatsapp from "./img/whatsapp.png"; // WhatsApp icon
import arrow from "./img/share.png"; // Arrow icon
import Navbar from "./components/Navbar"; // Ensure Navbar exists
import Footer from "./components/Footer"; // Ensure Footer exists
import moment from './img/moment.png';
import chat from './img/chat.png';
import app_store from './img/app_store.png';
import play_store from './img/play_store.png';

function App() {

  const instadir = () => {
    window.open("https://www.instagram.com/tomwellness?igsh=MTc1c3RqNGd2Nnk3cw==", "_blank", "noopener noreferrer")
  }
  const appstoredir = () => {
    window.open("https://apps.apple.com/us/app/tom-wellness/id1577478233", "_blank", "noopener noreferrer")
  }
  const playstoredir = () => {
    window.open("https://play.google.com/store/apps/details?id=com.tom.member", "_blank", "noopener noreferrer")
  }
  const youtubedir = () => {
    window.open("https://www.youtube.com/@TOMWellness", "_blank", "noopener noreferrer")
    console.log("You Tube Link");
    
  }
  const whatsappdir = () => {
    window.open("https://wa.me/+96555505305?text=Hi,%20I%20want%20to%20know%20more%20about%20your%20services!", "_blank", "noopener noreferrer")
    // window.open("https://wa.me/919876543210?text=Hi,%20I%20want%20to%20know%20more%20about%20your%20services!", "_blank", "noopener noreferrer")
  }

  return (
   
    <div className="app">
      <div className="background-container">
        <div className="content">
          <img src={logo} alt="Tom Logo" className="tom_logo"></img>
          <h2 className="subtitle">Your Social Wellness Platform</h2>
          <p className="arabic-text">معاك بكل لحظة</p>
          <div className="button-container">
            <div className="button row m-0" onClick={() => instadir()}>
              <div className="col-11 p-0">
                <div className="row m-0">
                  <div className="col-5 text-end p-0">
                    <span>Tom Moments</span>
                  </div>
                  <div className="col-2 p-0">
                    <img src={insta} alt="Instagram" className="icon" />
                  </div>
                  <div className="col-5 text-start p-0">
                    <span>TOM <img src={moment} style={{width:'50px',height:'22px'}} />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-1 p-0">
                <img src={arrow} alt="Arrow" className="arrow" />
              </div>
            </div>
            <div className="button row m-0" onClick={() => youtubedir()}>
              <div className="col-11 p-0">
                <div className="row m-0">
                  <div className="col-5 text-end p-0">
                    <span>Tom Moments</span>
                  </div>
                  <div className="col-2 p-0">
                    <img src={youtube} alt="YouTube" className="icon_youtube" />
                  </div>
                  <div className="col-5 text-start p-0">
                    <span>Tom <img src={moment} style={{width:'50px',height:'22px'}} /></span>
                  </div>
                </div>
              </div>
              <div className="col-1 p-0">
                <img src={arrow} alt="Arrow" className="arrow" />
              </div>
            </div>
            <div className="button row m-0" onClick={() => whatsappdir()}>
              <div className="col-11 p-0">
                <div className="row m-0">
                  <div className="col-5 text-end p-0">
                    <span>Chat with us</span>
                  </div>
                  <div className="col-2 p-0">
                    <img src={whatsapp} alt="WhatsApp" className="icon" />
                  </div>
                  <div className="col-5 text-start p-0">
                    <span><img src={chat} style={{width:'65px',height:'22px'}} /></span>
                  </div>
                </div>
              </div>
              <div className="col-1 p-0">
                <img src={arrow} alt="Arrow" className="arrow" />
              </div>
            </div>
            <div className="button row m-0" onClick={() => appstoredir()}>
              <div className="col-11 p-0">
                <div className="row m-0">
                  <div className="col-5 text-end p-0">
                    <span>App store</span>
                  </div>
                  <div className="col-2 p-0">
                    <img src={appStore} alt="App Store" className="icon_app" />
                  </div>
                  <div className="col-5 text-start p-0">
                    <span><img src={app_store} style={{width:'65px',height:'22px'}} /></span>
                  </div>
                </div>
              </div>
              <div className="col-1 p-0">
                <img src={arrow} alt="Arrow" className="arrow" />
              </div>
            </div>
            <div className="button row m-0" onClick={() => playstoredir()}>
              <div className="col-11 p-0">
                <div className="row m-0">
                  <div className="col-5 text-end p-0">
                    <span>Play Store</span>
                  </div>
                  <div className="col-2 p-0">
                    <img src={playStore} alt="Play Store" className="icon_play" />
                  </div>
                  <div className="col-5 text-start p-0">
                    <span><img src={play_store} style={{width:'65px',height:'22px'}} /></span>
                  </div>
                </div>
              </div>
              <div className="col-1 p-0">
                <img src={arrow} alt="Arrow" className="arrow" />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
